export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = 'FWrCf+pGUVIXyDBFljgA7WaNBY6SqzFMmeeJWri+QZ5Oj1UViM2dNL5pZVErak7o';

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
